import { ApiItemType } from '@highimpact-frontend/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tab, TextField, Typography } from '@mui/material';
import React, { ChangeEvent, KeyboardEvent } from 'react';
import PermissionDecoratorV2 from './PermissionDecoratorV2';

export interface NavigationTabProps {
  name: string;
  selected: boolean;
  renameable?: boolean;
  onRename?: (newName: string) => void;
  deletable?: boolean;
  onDelete?: () => void;
  onClick: () => void;

  isEditing: boolean;
  editingName: string;
  onEditingNameChange: (val: string) => void;
  onStartEditing: () => void;
  onCommitEditing: () => void;
  onCancelEditing: () => void;
  itemNameDeleteBtn?: ApiItemType;
  projectId?: number;
  siteId?: number;
  itemNameEditEl?: ApiItemType;
}

export const NavigationTab: React.FC<NavigationTabProps> = ({
  name,
  selected,
  renameable,
  deletable,
  onDelete,
  onClick,
  isEditing,
  editingName,
  onEditingNameChange,
  onStartEditing,
  onCommitEditing,
  onCancelEditing,
  itemNameDeleteBtn,
  projectId,
  siteId,
  itemNameEditEl,
}) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onCommitEditing();
    }
    if (e.key === 'Escape') {
      onCancelEditing();
    }
  };

  if (isEditing) {
    return (
      <Tab
        component="div"
        label={
          <TextField
            value={editingName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onEditingNameChange(e.target.value)
            }
            onBlur={() => onCommitEditing()}
            onKeyDown={handleKeyDown}
            size="small"
            autoFocus
          />
        }
      />
    );
  }

  return (
    <Tab
      component="div"
      label={
        <Box display="flex" alignItems="center">
          {selected && renameable && itemNameEditEl ? (
            <PermissionDecoratorV2
              item={itemNameEditEl}
              project_id={projectId}
              site_id={siteId}
            >
              <Typography
                onClick={(e) => {
                  e.stopPropagation();
                  onClick();
                  onStartEditing();
                }}
              >
                {name}
              </Typography>
            </PermissionDecoratorV2>
          ) : (
            <Typography
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
            >
              {name}
            </Typography>
          )}

          {selected && deletable && itemNameDeleteBtn && (
            <PermissionDecoratorV2
              item={itemNameDeleteBtn}
              project_id={projectId}
              site_id={siteId}
            >
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.();
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </PermissionDecoratorV2>
          )}
        </Box>
      }
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-selected={selected}
    />
  );
};
